const FONT_LOADERS: Record<string, () => Promise<unknown>> = {
  'DM Sans': () => import('./loaders/dmSans'),
  Montserrat: () => import('./loaders/montserrat'),
};

const loadedFonts = new Set<string>();
const loadingFonts = new Map<string, Promise<void>>();

export function isGoogleFontSupported(fontFamily: string): boolean {
  return fontFamily in FONT_LOADERS;
}

export async function loadGoogleFont(fontFamily: string): Promise<void> {
  const loader = FONT_LOADERS[fontFamily];

  if (!loader) {
    console.warn(`loadGoogleFont: unsupported font "${fontFamily}". Skipping dynamic load.`);
    return;
  }

  if (loadedFonts.has(fontFamily)) {
    return;
  }

  const inFlight = loadingFonts.get(fontFamily);
  if (inFlight) {
    return inFlight;
  }

  const loadPromise = loader()
    .then(() => {
      loadedFonts.add(fontFamily);
    })
    .finally(() => {
      loadingFonts.delete(fontFamily);
    });

  loadingFonts.set(fontFamily, loadPromise);
  return loadPromise;
}

/** @internal Test helper */
export function resetLoadedGoogleFontsForTests(): void {
  loadedFonts.clear();
  loadingFonts.clear();
}
